import { Components, Theme } from "@mui/material";

export const MuiSelect: Components<Theme>["MuiSelect"] = {
  variants: [
    {
      props: {
        variant: "standard",
      },
      style: {},
    },
  ],

  styleOverrides: {
    root: ({ theme }) => {
      return {
        ...theme.typography.formInput,
        paddingTop: "0rem",
        height: "2.5rem",
        paddingBottom: "0rem",
        // alignItems: 'center'
      };
    },
    icon: ({ theme }) => {
      return {
        stroke: theme.palette.primary.main,
      };
    },
  },
};
